<template>
  <div :id="'container' + id" class="enterCodeScreen" :class="process">
    <div class="leftContent">
      <custom-header :img-number="callEnabled ? 12 : 11"></custom-header>
    </div>
    <div class="rightContent">
      <div class="headBlock">
        <custom-header />
      </div>
      <div class="wrap enterCodeScreen_content">
        <div class="grow"></div>
        <h2>{{ title }}</h2>
        <div class="helpText">
          <div v-html="helpText"></div>
          <slot></slot>
        </div>
        <div class="enterCodeScreen_codeBlock" :class="{notValid: isError}" @keydown.stop="downEvent">
          <!--<div v-for="index in verifyCodeLength">-->
          <!--<input  class="enterCodeScreen_input" type="number" value=""  @input.stop="inputEvent"/>-->
          <!--<div v-if="index%2 === 0" class="enterCodeScreen_inputHr">–</div>-->
          <!--</div>-->
          <input
            ref="firstInput"
            class="enterCodeScreen_input h2"
            inputmode="numeric"
            v-model="verifyCode[0]"
            :disabled="nextButtonDisabled"
            @input.stop="inputEvent(0, $event)"
            @paste="pasteEvent(0, $event)"
            @keydown.enter="next"
            @focus="inputOnFocus"
            autocomplete="one-time-code"
          />
          <input
            class="enterCodeScreen_input h2"
            inputmode="numeric"
            v-model="verifyCode[1]"
            :disabled="nextButtonDisabled"
            @input.stop="inputEvent(1, $event)"
            @paste="pasteEvent(1, $event)"
            @keydown.enter="next"
            @focus="inputOnFocus"
            autocomplete="one-time-code"
          />
          <div class="enterCodeScreen_inputHr">–</div>
          <input
            class="enterCodeScreen_input h2"
            inputmode="numeric"
            v-model="verifyCode[2]"
            :disabled="nextButtonDisabled"
            @input.stop="inputEvent(2, $event)"
            @paste="pasteEvent(2, $event)"
            @keydown.enter="next"
            @focus="inputOnFocus"
            autocomplete="one-time-code"
          />
          <input
            class="enterCodeScreen_input h2"
            inputmode="numeric"
            v-model="verifyCode[3]"
            :disabled="nextButtonDisabled"
            @input.stop="inputEvent(3, $event)"
            @paste="pasteEvent(3, $event)"
            @keydown.enter="next"
            @focus="inputOnFocus"
            autocomplete="one-time-code"
          />
          <div class="enterCodeScreen_inputHr">–</div>
          <input
            class="enterCodeScreen_input h2"
            inputmode="numeric"
            v-model="verifyCode[4]"
            :disabled="nextButtonDisabled"
            @input.stop="inputEvent(4, $event)"
            @paste="pasteEvent(4, $event)"
            @keydown.enter="next"
            @focus="inputOnFocus"
            autocomplete="one-time-code"
          />
          <input
            ref="lastInput"
            class="enterCodeScreen_input h2"
            inputmode="numeric"
            v-model="verifyCode[5]"
            :disabled="nextButtonDisabled"
            @input.stop="inputEvent(5, $event)"
            @paste="pasteEvent(5, $event)"
            @keydown.enter="next"
            @focus="inputOnFocus"
            autocomplete="one-time-code"
          />
        </div>
        <div v-if="isError" class="validText">{{ errorMessage }}</div>

        <a v-show="!isCalling" class="enterCodeScreen_repeat" :class="{disable: repeatTime, nextButtonDisabled: nextButtonDisabled}" @click.stop="resendCode">{{ repeatMessage }}</a>

        <div class="grow"></div>
        <div class="bottom">
          <div class="left">
            <custom-button :button-text="$ml.get('back')" back :action="back"></custom-button>
          </div>
          <div class="right">
            <custom-button :button-text="$ml.get('next')" success :action="next" :disabled="nextButtonDisabled"></custom-button>
          </div>
        </div>
        <a v-if="callEnabled" class="enterCodeScreen_call" :class="{disable: callTime, nextButtonDisabled: nextButtonDisabled}" @click.stop="sendCodeByCall">{{ callMessage }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CustomHeader from '../ui/custom-header';
import CustomButton from '../ui/custom-button';
import {resendSms as apiResendSms, sendCodeByCall as apiSendCodeByCall, getApiErrorMessage, resendSmsForSecondOtp, sendCodeByCallForSecondOtp, resendSmsForThirdOtp, sendCodeByCallForThirdOtp} from '../../helpers/api';
import Profile from '../../helpers/profile';

const DEFAULT_REPEAT_TIME = 30;
const DEFAULT_CALL_TIME = 30;

export default {
  name: 'enterCode-screen',
  components: {CustomButton, CustomHeader},
  props: {
    value: String,
    id: String,
    title: String,
    helpText: String,
    nextButtonDisabled: Boolean,
  },
  data() {
    return {
      verifyCodeLength: 6,
      verifyCode: this.value.split(''),

      repeatTime: 0,
      repeatInterval: null,
      repeatMessage: this.$ml.get('enterCodeSendAgain'),
      callTime: 0,
      callInterval: null,
      callMessage: this.$ml.get('enterCodeGetCall'),
      isCalling: false,
      //                isMobile: false,
      isError: false,
      isErrorTimeout: null,
      errorMessage: '',
      process: Profile.process,
    };
  },

  mounted() {
    //            this.isMobile = window.innerWidth < 600;
    this.startRepeatTimer();
    if (this.value.length > 0) this.$refs.lastInput.focus();
    else this.$refs.firstInput.focus();
  },
  computed: {
    code: function() {
      return this.verifyCode.join('');
    },

    callEnabled: function() {
      return (!Profile.secondOTP.username && (Profile.otptype === 'sms' || Profile.otptype === 'voip')) || (Profile.secondOTP.username && (Profile.secondOTP.otptype === 'sms' || Profile.secondOTP.otptype === 'voip'));
    },
  },

  methods: {
    inputEvent(index, event) {
      let value = event.target.value;
      value = value.replace(/\D/g, '');
      if (value.length === this.verifyCodeLength) {
        for (let i = 0; i < value.length; i++) this.verifyCode[i] = value[i];
        Vue.nextTick(() => {
          let input = this.$refs.lastInput;
          input.focus();
          input.setSelectionRange(input.value.length, input.value.length);
        });
      } else if (value.length > 1) {
        this.verifyCode[index] = value.substr(0, 1);
      } else this.verifyCode[index] = value;

      if (!this.verifyCode[index].length) return;
      // if (!(/^\d+$/.test(value)) && value != '') {
      //     Vue.nextTick().then(() => {
      //         this.verifyCode[index] = value.replace(/\D/g, '');
      //     });
      //     return;
      // }
      this.code.length === this.verifyCodeLength ? this.nextElement(event) : event.target.value && this.nextElement(event);
    },
    nextElement(event) {
      let nextSibling = event.target.nextElementSibling;
      if (nextSibling) {
        if (nextSibling.classList.contains('enterCodeScreen_inputHr')) nextSibling = nextSibling.nextElementSibling;
        nextSibling.focus();
      }
      //                else {
      //                    Vue.nextTick(() => {
      //                        if (this.code.length === this.verifyCodeLength)
      //                            this.next();
      //                    });
      //                }
    },
    previousElement(event) {
      let previousSibling = event.target.previousElementSibling;
      if (previousSibling) {
        if (previousSibling.classList.contains('enterCodeScreen_inputHr')) previousSibling = previousSibling.previousElementSibling;
        previousSibling.focus();
      }
    },
    downEvent: function(event) {
      var keyCode = event.which || event.keyCode;
      if (keyCode === 8 && !event.target.value) {
        this.previousElement(event);
      } else if (keyCode >= 37 && keyCode <= 41) {
        switch (keyCode) {
          case 37:
            this.previousElement(event);
            break;
          case 39:
            this.nextElement(event);
            break;
        }
        // if (_sibling) { // todo maybe add set focus on firs element
        //     _sibling.firstChild.focus()
        // }
        event.preventDefault();
        // return [event.preventDefault(), false]
      }
    },
    //            getVerifyCode: function () {
    //                return this.verifyCode.join('')
    //            },
    pasteEvent: function(index, event) {
      if (event.clipboardData && event.clipboardData.getData) {
        let pasteData = event.clipboardData.getData('Text').replace(/[^0-9]/g, '');
        let indexPaste = index || 0;
        if (pasteData.length) {
          pasteData = pasteData.split('');
          pasteData.forEach(item => {
            if (indexPaste >= this.verifyCodeLength) {
              return;
            }
            item = item.replace(/\D/g, '');
            if (item.length) {
              this.verifyCode[indexPaste] = item;
              indexPaste++;
            }
          });
        }
      }
    },
    startRepeatTimer: function() {
      if (this.repeatInterval && this.repeatTime) return;
      this.repeatTime = DEFAULT_REPEAT_TIME;
      this.repeatMessage = this.$ml.get('enterCodeRepeatThrough') + ' ' + this.repeatTime + ' ' + this.$ml.get('enterCodeSeconds');
      this.repeatInterval = setInterval(() => {
        this.repeatTime--;
        if (this.repeatTime <= 0) {
          this.stopRepeatTimer();
        } else this.repeatMessage = this.$ml.get('enterCodeRepeatThrough') + ' ' + this.repeatTime + ' ' + this.$ml.get('enterCodeSeconds');
      }, 1000);
    },

    stopRepeatTimer: function() {
      this.repeatTime = 0;
      clearInterval(this.repeatInterval);
      this.repeatInterval = null;
      this.repeatMessage = this.$ml.get('enterCodeSendAgain');
    },

    startCallTimer: function() {
      if (this.callInterval && this.callTime) return;
      this.callTime = DEFAULT_CALL_TIME;
      this.callMessage = this.$ml.get('enterCodeRepeatCallThrough') + ' ' + this.callTime + ' ' + this.$ml.get('enterCodeSeconds');
      this.callInterval = setInterval(() => {
        this.callTime--;
        if (this.callTime <= 0) {
          this.stopCallTimer();
        } else this.callMessage = this.$ml.get('enterCodeRepeatCallThrough') + ' ' + this.callTime + ' ' + this.$ml.get('enterCodeSeconds');
      }, 1000);
    },

    stopCallTimer: function() {
      this.callTime = 0;
      clearInterval(this.callInterval);
      this.callInterval = null;
      this.callMessage = this.$ml.get('enterCodeGetCall');
    },

    back: function() {
      this.$emit('back', true);
    },
    next: function() {
      if (this.code.length !== this.verifyCodeLength) {
        this.showError(this.$ml.get('enterCodeValidationEmpty'));
      } else {
        this.$emit('next', this.code);
      }
    },

    resetInputs: function() {
      this.verifyCode = new Array(6);
      Vue.nextTick(() => {
        if (this.$refs.firstInput) this.$refs.firstInput.focus();
      });
    },

    showError: function(message = '') {
      this.errorMessage = message;
      //                this.resetInputs();
      this.isError = true;
      clearTimeout(this.isErrorTimeout);
      this.isErrorTimeout = setTimeout(() => {
        this.errorMessage = '';
        this.isError = false;
      }, 3000);
    },

    resendCode: function() {
      if ((this.repeatInterval && this.repeatTime) || this.nextButtonDisabled) return;
      this.startRepeatTimer();
      this.resetInputs();
      if (Profile.thirdOTP.username) {
        resendSmsForThirdOtp().then(
          () => {},
          err => {
            this.showError(getApiErrorMessage(err));
            this.stopRepeatTimer();
          }
        );
      } else if (Profile.secondOTP.username) {
        resendSmsForSecondOtp().then(
          () => {},
          err => {
            this.showError(getApiErrorMessage(err));
            this.stopRepeatTimer();
          }
        );
      } else
        apiResendSms().then(
          () => {},
          err => {
            this.showError(getApiErrorMessage(err));
            this.stopRepeatTimer();
          }
        );
    },

    sendCodeByCall: function() {
      if (this.callInterval && this.callTime) return;
      this.isCalling = true;
      this.startCallTimer();
      this.resetInputs();
      if (Profile.thirdOTP.username) {
        sendCodeByCallForThirdOtp()
          .then(
            () => {},
            err => {
              this.showError(getApiErrorMessage(err));
              this.stopCallTimer();
            }
          )
          .finally(() => {
            this.isCalling = false;
          });
      } else if (Profile.secondOTP.username) {
        sendCodeByCallForSecondOtp()
          .then(
            () => {},
            err => {
              this.showError(getApiErrorMessage(err));
              this.stopCallTimer();
            }
          )
          .finally(() => {
            this.isCalling = false;
          });
      } else
        apiSendCodeByCall()
          .then(
            () => {},
            err => {
              this.showError(getApiErrorMessage(err));
              this.stopCallTimer();
            }
          )
          .finally(() => {
            this.isCalling = false;
          });
    },

    inputOnFocus: function(event) {
      event.target.setSelectionRange(0, event.target.value.length);
    },
  },
};
</script>

<style lang="scss" scoped>
.enterCodeScreen_content {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 150px);
  justify-content: space-between;
  padding: 10% 6% 0;
  .enterCodeScreen_codeBlock {
    margin-top: 26px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-self: center;
    max-width: 359px;
    &.notValid input {
      border: 2px solid #ec3421;
      box-sizing: border-box;
      border-radius: 8px;
    }
    .enterCodeScreen_input {
      width: 38px;
      height: 46px;
      margin: 0 2px;
      padding: 0 0 2px;
      border: 1px solid #bdd6e6;
      box-sizing: border-box;
      border-radius: 8px;
      color: #434343;
      text-align: center;
      box-shadow: none;
      -webkit-appearance: none;
      font-weight: 500;
      &:focus {
        outline: none;
      }
    }
    .enterCodeScreen_inputHr {
      display: flex;
      align-items: center;
      margin: 0 4px;
      color: #bdd6e6;
    }
  }
  .helpText,
  .link {
    text-align: left;
  }
  a {
    color: #5cd69b;
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    margin: 12px 0;
    &:not(.disable) {
      cursor: pointer;
    }
    &.disable {
      font-weight: 300;
      font-size: 12px;
      color: #7b7b7b;
      &:hover {
        color: #7b7b7b;
        text-decoration: none;
      }
    }
    &.nextButtonDisabled:not(.disable) {
      color: #c3c3c3;
      &:hover,
      &:focus {
        cursor: default;
        color: #c3c3c3;
        text-decoration: none;
      }
    }
  }

  .enterCodeScreen_repeat {
    margin: 30px 0;
  }
}

.validText {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  margin: 4px auto -18px;
  color: #e53935;
  text-align: left;
  width: 285px;
  padding-right: 5px;
}

@media (max-width: 600px) {
  .bottom {
    .left {
      display: block;
      width: 40%;
      float: left;
    }
    .right {
      display: block;
      width: 56%;
      float: right;
    }
  }
}
@media (min-width: 601px) and (max-width: 750px) {
  .enterCodeScreen_content {
    height: calc(100vh - 220px);
    max-height: 700px;
    .enterCodeScreen_codeBlock {
      margin-top: 52px;
    }
  }
  .enterCodeScreen:not(.accessRecovery) .bottom {
    .left {
      display: none;
    }
    .right {
      width: 100%;
      float: none;
    }
  }
}
@media (min-width: 751px) {
  .enterCodeScreen_content {
    height: calc(100vh - 160px);
    max-height: 700px;
  }
  .enterCodeScreen:not(.accessRecovery) .bottom {
    .left {
      display: none;
    }
    .right {
      width: 100%;
      float: none;
    }
  }
}

@media (min-width: 1024px) {
  .enterCodeScreen_content {
    .enterCodeScreen_codeBlock {
      margin-top: 52px;
      .enterCodeScreen_input {
        width: 46px;
        height: 52px;
        margin: 0 4px;
      }
    }
  }
  .validText {
    margin: 4px auto 0;
    width: 345px;
  }
}
</style>
